import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateTime'
})
export class DateTimePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    switch (args) {
      case 'date':
        return moment(value, 'ddd').format('dddd');
      case 'time':
        const arr = value.split(':');
        return moment({ hour: arr[0], minute: arr[1], seconds: arr[2] }).format('hh:mm A');
      default:
        return value;
    }
  }
}
